import { config } from '../../config/buyout';

export const state = {
	campaignIdentifier: 'base',
	campaign: null,
	categories: [],
	brands: [],
	models: [],
	colors: [],
	selectedCategory: null,
	selectedBrand: null,
	selectedModel: null,
	selectedColor: null,
	loadingCategories: false,
	loadingBrands: false,
	loadingModels: false,
	loadingColors: false,
	loadingAppraisal: false,
	genders: [],
	states: [],
	contractForm: {
		buyout_device: {
			imei: '',
			note: '',
			order_number: '',
			new_device_imei: '',
		},
		customer_data: {
			personal_identification_number: '',
			identity_card_number: '',
			identity_released_by: '',
			identity_valid_to: '',
			degree_before_name: '',
			first_name: '',
			last_name: '',
			gender: null,
			street: '',
			city: '',
			country_identifier: '',
			postcode: '',
			phone_number: null,
			nationality: '',
			place_of_birth: '',
			e_mail: '',
			bank_code: config.default_bank_code,
			bank_account_full_number: '00-0000000000'
		}
	},
	qualities: [],
	qualityTypes: [],
	selectedQuality: null,
	appraisal: null,
	userBuyoutCode: null,
	canNotBeBuyout: false,
	displayThankYou: false,
	isAppraisalEditable: true,
	appraisalErrors: {},
	appraisalResults: [],
	appraisalLoadError: null,
	defaultQualityConditions: [],
	buyoutBonuses: [],
	isPreSaleInfo: false,
	isBuyoutOnline: false,
	preSaleInfoEmail: null,
	buyoutLoadError: null,
	buyoutState: null,
	isRegistration: true,
	isLoggedIn: false,
	selectedBonus: null,
	buyoutReceipt: null,
	buyoutReceiptErrors: null,
	pickupAddress: {
		street: null,
		city: null,
		post_code: null
	},
	pickupAddressErrors: null,
	newDeviceImei: null,
	newDeviceImeiErrors: {},
	newDeviceImeiSaved: false,
	editableImei: false,
	disableBuyoutSendBtn: false,
	stateTypes: [],
	buyoutStateIdentifier: null,
	commonError: false,
	partners: [],
	selectedPartner: null,
	consentToMarketing: false,
	buyoutAdditionalInfo: {
		esd_single_licence: {
			activation_code: ''
		},
		selected_new_model: ''
	},
	buyoutAdditionalInfoErrors: {},
	buyoutLoading: false,
	isDifferentPickupAddress: false,
	selectedNewModel: null,
	selectedNewModelPartner: null,
}
